/**
 * Formate une date ISO ("YYYY-MM-DD", éventuellement suivie d'une heure)
 * au format français "JJ/MM/AAAA" attendu par les utilisateurs gabonais.
 * Découpage en chaîne plutôt que new Date() pour éviter tout décalage de
 * fuseau horaire (un Date construit depuis "YYYY-MM-DD" est interprété en
 * UTC par le moteur JS, ce qui peut faire glisser le jour affiché de -1
 * selon le fuseau du navigateur).
 */
export function formatDateFR(isoDate) {
  if (!isoDate || typeof isoDate !== "string") return isoDate || "";
  const datePart = isoDate.split("T")[0].split(" ")[0];
  const [year, month, day] = datePart.split("-");
  if (!year || !month || !day || year.length !== 4) return isoDate;
  return `${day}/${month}/${year}`;
}

/**
 * Formate une date ISO avec le jour de la semaine et le mois en toutes
 * lettres, ex : "mardi 15 septembre 2026".
 */
export function formatDateFRLong(isoDate) {
  if (!isoDate || typeof isoDate !== "string") return isoDate || "";
  const datePart = isoDate.split("T")[0].split(" ")[0];
  try {
    return new Date(datePart + "T00:00:00").toLocaleDateString("fr-FR", { weekday: "long", day: "2-digit", month: "long", year: "numeric" });
  } catch {
    return formatDateFR(isoDate);
  }
}
